import * as R from 'ramda';
import { compose, withState, withHandlers, withPropsOnChange} from 'react-recompose';
// helpers/constants
import * as G from '../helpers';
//////////////////////////////////////////////////

export const composeObjectPropsToString = (
  omitFields = [],
  withoutValues = [],
  joiner = '',
) => R.compose(
  R.toLower(),
  R.join(joiner),
  R.without(withoutValues),
  R.values(),
  R.omit(omitFields),
);

export const mapListObjectPropsToPropString = (filterPropName, composeProps) => R.map(
  (item) => R.assoc(
    filterPropName,
    composeObjectPropsToString(
    R.prop('omitFields', composeProps),
    R.prop('withoutValues', composeProps),
    R.prop('joiner', composeProps),
    )(item),
    item,
  ),
);

export const filterListOfObjectsByPropContains = (
  filterString,
  filterPropName,
  ) => R.filter(
  (item) => R.propSatisfies(
    (prop) => R.includes(R.toLower(filterString), prop), filterPropName, item,
  ),
);

export const withFilterTableList = (
  filterPropName,
  originState,
  pathToOriginList,
  composeProps,
) => compose(
  withState('filterString', 'setFilterString', ''),
  withState('filteredTableList', 'setFilteredTableList', []),
  withHandlers({
    handleChangeFilterInput: (props) => (value) => props.setFilterString(value),
  }),
  withPropsOnChange(['filterString', originState], (props) => {
    const { filterString, setFilteredTableList} = props;
    const originList = R.path(pathToOriginList, props);
    if (G.isNilOrEmpty(filterString)) return setFilteredTableList(originList);
    const mappedList = mapListObjectPropsToPropString(
      filterPropName,
      composeProps,
    )(originList);
    const filteredList = filterListOfObjectsByPropContains(
      filterString,
      filterPropName,
    )(mappedList);
    setFilteredTableList(filteredList);
  }),
);
